import React, { useEffect, useState } from 'react'
import { BsFillBookmarksFill } from 'react-icons/bs'
import { formatPipe } from '../../utils/utils'

const WatchWithholding: React.FC<IWatchWithholding> = ({ sale }) => {
  const [windowSize, setWindowSize] = useState(getWindowSize())

  useEffect(() => {
    function handleWindowResize() {
      setWindowSize(getWindowSize())
    }

    window.addEventListener('resize', handleWindowResize)

    return () => {
      window.removeEventListener('resize', handleWindowResize)
    }
  }, [])

  function getWindowSize() {
    const { innerWidth, innerHeight } = window
    return { innerWidth, innerHeight }
  }

  const [withholding, setWithholding] = useState<any[]>([])

  useEffect(() => {
    console.log('SALE', sale)
    let value: any[] = []
    if (sale?.withholding?.amountWithheld !== null) {
      value.push({ ...sale?.withholding, type: 'Retención IVA' })
    }
    if (sale?.islrWithholding?.amountWithheld !== null) {
      value.push({ ...sale?.islrWithholding, type: 'Retención ISLR' })
    }

    if (sale?.aeWithholding?.amountWithheld !== null) {
      value.push({
        ...sale?.aeWithholding,
        type: 'Retención Impuesto Municipal',
      })
    }

    if (sale?.otherTaxWithholding?.length > 0) {
      value.push(
        ...sale?.otherTaxWithholding.map((v) => ({
          ...v,
          type: 'Otras retenciones',
        }))
      )
    }
    setWithholding(value)
  }, [sale])

  return (
    <div>
      <h2 className="font-medium">Retenciones</h2>
      <div className={`grid grid-cols-2 gap-4 mt-5`}>
        {withholding.map((v, i) => (
          <div
            style={{
              maxHeight: 220,
              borderRadius: 10,
              backgroundColor: '#F2F2F2',
              overflowY: 'auto',
            }}
            className="p-5"
          >
            <div className="flex items-center">
              <div
                style={{
                  height: 24,
                  width: 24,
                  backgroundColor: '#D9D9D999',
                  borderRadius: 3,
                }}
                className="flex justify-center items-center mr-3"
              >
                <BsFillBookmarksFill
                  style={{ color: i % 2 === 0 ? '#006AEA' : '#0033A0' }}
                />
              </div>
              <h2 className="font-medium">{v?.type}</h2>
            </div>

            {v?.description && (
              <div className="truncate">
                <label
                  className="text-sm font-medium mt-2"
                  style={{
                    maxWidth: '100%',
                    lineBreak: 'anywhere',
                  }}
                >
                  Descripción: {v?.description}
                </label>
              </div>
            )}

            {/* Layout específico para ISLR */}
            {v?.type === 'Retención ISLR' ? (
              <>
                {/* Fila 1: No. de comprobante solo */}
                <div className="mt-2">
                  <label
                    className="text-sm font-medium"
                    style={{ lineBreak: 'anywhere' }}
                  >
                    No. de comprobante: {v?.voucherNumber}
                  </label>
                </div>

                {/* Fila 2: Concepto | Código */}
                <div className="flex justify-between flex-row">
                  <label
                    className="text-sm font-medium mt-2 mr-2"
                    style={{ maxWidth: '50%', lineBreak: 'anywhere' }}
                  >
                    Concepto: {v?.concept || 'N/A'}
                  </label>
                  <label
                    className="text-sm font-medium mt-2"
                    style={{ maxWidth: '50%', textAlign: 'end', lineBreak: 'anywhere' }}
                  >
                    Código: {v?.code || 'N/A'}
                  </label>
                </div>

                {/* Fila 3: Monto retenido | Base imponible */}
                <div className="flex justify-between flex-row">
                  <label
                    className="text-sm font-medium mt-2 mr-2"
                    style={{ maxWidth: '50%', lineBreak: 'anywhere' }}
                  >
                    Monto retenido: Bs {formatPipe(v?.amountWithheld)}
                  </label>
                  <label
                    className="text-sm font-medium mt-2"
                    style={{ maxWidth: '50%', textAlign: 'end', lineBreak: 'anywhere' }}
                  >
                    Base imponible: Bs {formatPipe(v?.taxBase)}
                  </label>
                </div>

                {/* Fila 4: Total impuesto | Porcentaje retenido */}
                <div className="flex justify-between flex-row">
                  <label
                    className="text-sm font-medium mt-2 mr-2"
                    style={{ maxWidth: '50%', lineBreak: 'anywhere' }}
                  >
                    Total impuesto: Bs {formatPipe(v?.taxTotal)}
                  </label>
                  <label
                    className="text-sm font-medium mt-2"
                    style={{ maxWidth: '50%', textAlign: 'end', lineBreak: 'anywhere' }}
                  >
                    Porcentaje retenido: {v?.withholdingPercentage}%
                  </label>
                </div>
              </>
            ) : (
              <>
                {/* Layout original para otras retenciones */}
                <div className={`flex justify-between flex-row`}>
                  <label
                    className="text-sm font-medium mt-2 mr-2"
                    style={{
                      maxWidth: '50%',
                      lineBreak: 'anywhere',
                    }}
                  >
                    Monto retenido: Bs {formatPipe(v?.amountWithheld)}
                  </label>
                  <label
                    className="text-sm font-medium mt-2"
                    style={{
                      maxWidth: '50%',
                      textAlign: 'end',
                      lineBreak: 'anywhere',
                    }}
                  >
                    Alícuota {formatPipe(v?.taxRate)}%
                  </label>
                </div>

                <div className={`flex justify-between flex-row`}>
                  <label
                    className="text-sm font-medium mt-2 mr-2"
                    style={{
                      maxWidth: '50%',
                      lineBreak: 'anywhere',
                    }}
                  >
                    No. de comprobante: {v?.voucherNumber}
                  </label>
                  <label
                    className="text-sm font-medium mt-2"
                    style={{
                      textAlign: 'end',
                      maxWidth: '50%',
                      lineBreak: 'anywhere',
                    }}
                  >
                    Base imponible: Bs {formatPipe(v?.taxBase)}
                  </label>
                </div>

                <div className={`flex justify-between flex-row`}>
                  <label
                    className="text-sm font-medium mt-2 mr-2"
                    style={{
                      maxWidth: '50%',
                      lineBreak: 'anywhere',
                    }}
                  >
                    Total impuesto: Bs {formatPipe(v?.taxTotal)}
                  </label>
                  {v?.excempt && (
                    <label
                      className="text-sm font-medium mt-2"
                      style={{
                        textAlign: 'end',
                        maxWidth: '50%',
                        lineBreak: 'anywhere',
                      }}
                    >
                      Exento: Bs {formatPipe(v?.excempt)}
                    </label>
                  )}
                </div>

                <div className={`flex justify-between flex-row`}>
                  <label
                    className="text-sm font-medium mt-2 mr-2"
                    style={{
                      maxWidth: '50%',
                      lineBreak: 'anywhere',
                    }}
                  >
                    Porcentaje retenido: {v?.withholdingPercentage}%
                  </label>
                </div>
              </>
            )}
          </div>
        ))}
      </div>
    </div>
  )
}

interface IWatchWithholding {
  sale: any
}

export default WatchWithholding
